"use es6";

const motionComponentSymbol = Symbol.for("motionComponentSymbol");
export { motionComponentSymbol };